module.exports = __webpack_public_path__ + "static/customer_bithumb_logo-5018617a1eabb4c977871f71939e9e92.svg";